import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/use-auth';

interface MainLayoutProps {
  children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-900">
      <nav className="bg-gray-800 border-b border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 space-y-2">
          <Link
            to="/scan"
            className="block text-xl font-bold text-white whitespace-nowrap"
          >
            par-excellence-proto
          </Link>
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-4 sm:gap-6 min-w-0">
              <Link
                to="/scan"
                className="text-sm text-gray-300 hover:text-white whitespace-nowrap"
                data-testid="scan-nav-link"
              >
                Scan
              </Link>
              <Link
                to="/cycle-count"
                className="text-sm text-gray-300 hover:text-white whitespace-nowrap"
                data-testid="cycle-count-nav-link"
              >
                Cycle Count
              </Link>
              {user?.role === 'Admin' && (
                <Link
                  to="/admin/users"
                  className="text-sm text-gray-300 hover:text-white whitespace-nowrap"
                  data-testid="users-nav-link"
                >
                  Users
                </Link>
              )}
            </div>

            <div className="flex items-center gap-3 shrink-0">
              <span
                className="text-sm text-gray-300 max-w-[10rem] sm:max-w-[16rem] truncate"
                title={`${user?.firstName ?? ''} ${user?.lastName ?? ''}`}
              >
                {user?.firstName} {user?.lastName}
              </span>
              <button
                onClick={handleLogout}
                className="px-3 sm:px-4 py-2 text-sm bg-gray-700 hover:bg-gray-600 rounded transition-colors whitespace-nowrap"
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      </nav>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  );
}
